<mat-form-field class="form-field form-field-full-width cz-user-select">
  <mat-label *ngIf="label">{{label}}</mat-label>
  <input [formControl]="filterControl" matInput type="text" [matAutocomplete]="autoUser" required>
  <mat-icon matSuffix class="suffix">arrow_drop_down</mat-icon>
  <mat-autocomplete #autoUser="matAutocomplete" 
                    [displayWith]="autocompleteUserOption"
                    (optionSelected)="userSelected($event)">
    <mat-option *ngFor="let option of filteredUserOptions | async" [value]="option">
      <span class="user-select-item">
        <span class="name">{{option?.firstName}} {{option?.lastName}}</span><br/>
        <span class="user-name font-size-small">{{option?.userName}}</span>
      </span>
    </mat-option>
  </mat-autocomplete>
</mat-form-field>